import React from "react";

import styles from "./styles.scss";
import { useTranslation } from "react-i18next";

function AddProjectButton() {
  const { t } = useTranslation();

  return (
    <button className={styles.addZoneButton}>
      <div className={styles.iconBox}>+</div>
      <p>{t("zonesPage.addProject")}</p>
    </button>
  );
}

export { AddProjectButton };
